import React, { useEffect, useState } from 'react';

import { StackView, Paragraph, Divider, Typography } from '@telus-uds/components-web';

import { ContentWrapper } from '../design/css';

const Success = () => {
  const [outlet, setOutlet] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('signContractToken');
    
    if (token) {
      try {
        // Decode JWT token (base64 decode the payload part)
        const tokenParts = token.split('.');
        if (tokenParts.length === 3) {
          const payload = JSON.parse(atob(tokenParts[1]));
          setOutlet(payload.currentUser && payload.currentUser.outlet);
        }
      } catch (error) {
        console.error('Error decoding token:', error);
      }
      // Clean up the token from localStorage
      localStorage.removeItem('signContractToken');
    }
    setLoading(false);
  }, []);

  const isSpecialOutlet = outlet === '1100055268';

  if (loading) {
    return (
      <div className="container 85%">
        <ContentWrapper style={{ minHeight: 'auto' }}>
          <Paragraph>Loading...</Paragraph>
        </ContentWrapper>
      </div>
    );
  }

  return (
    <>
      <StackView space={4}>
        <Divider />
      </StackView>
      <div className="container 85%">
        <ContentWrapper style={{ minHeight: 'auto' }}>
          <Paragraph>
            Thank you for choosing TELUS Fully Managed. Our Managed IT services
            support your day-to-day IT needs so you can stay focused on what's
            important. We have received confirmation of the customer agreement
            and will proceed with setting up your solution as requested.
          </Paragraph>
          {!isSpecialOutlet && (
            <>
              <Paragraph>
                The next step is for you to complete our Customer Activation Form,
                located here:{' '}
                <a
                  href="https://forms.office.com/pages/responsepage.aspx?id=RNW-_drO10WnY9xoJQTfFzZ_a5qDdzROuvwnPq9obT9URjAzSjVGREtUR09aN0ZGSU8wUEo1SkhMWi4u"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Typography>Customer Activation Form</Typography>
                </a>
              </Paragraph>
            </>
          )}
          <Paragraph>
            If you have questions about your TELUS Fully Managed solution,
            please contact your Account Manager.
          </Paragraph>
        </ContentWrapper>
      </div>
    </>
  );
};

export default Success;
